<!--
 * @Description: 新增/分配区域
 * @Author: cxh
 * @Date: 2022-06-09 10:24:45
 * @LastEditTime: 2023-06-15 16:10:23
 * @LastEditors: cxh
-->
<template>
  <cos-modal
    v-model:visible="visible"
    :title="editForm.id ? '分配区域' : '新增'"
    class="clueMerge"
    width="670px"
    @ok="handleSubmit"
    :confirmLoading="loading"
  >
    <a-form :model="editForm" ref="formRef" v-if="visible">
      <a-form-item name="employeeNo" label="员工" :rules="[{ required: true, message: '请选择' }]">
        <UserSelect
          :disabled="editForm.id ? true : false"
          v-model:value="editForm.employeeNo"
          placeholder="请选择"
          allowClear
        />
      </a-form-item>
      <a-form-item name="areaId" label="分配区域" :rules="[{ required: true, message: '请选择' }]">
        <a-tree-select
          v-model:value="editForm.areaId"
          show-search
          style="width: 100%"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          placeholder="请选择"
          allow-clear
          multiple
          :tree-data="customerAreaEnum"
          tree-node-filter-prop="label"
          :fieldNames="{children:'children', label:'label', value: 'id' }"
        >
        </a-tree-select>
        <!-- <CustomerAreaCascader
          change-on-select
          appId="cos_fbu"
          deptInfoId="815717"
          :multiple="true"
          v-model:value="editForm.areaId"
        /> -->
      </a-form-item>
    </a-form>
  </cos-modal>
</template>
<script lang="ts" setup>
import { ref } from 'vue'
import { DcMessage } from '@dc-platform/dc-components'
import useHook from '@/components/CustomerAreaCascader/useHook'
// import CustomerAreaCascader from '@/components/CustomerAreaCascader/CustomerKeyData.vue'
import type { ClueReceiveListItem } from '@/typings/api/marketingManage'
import { clueReceiveAdd, clueReceiveEdit } from '@/api/marketing/marketingManage'
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref()
const editForm = ref<ClueReceiveListItem>({})
const emit = defineEmits(['success'])
const { customerAreaEnum } = useHook('cos_fbu', '815717')
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    let fun = clueReceiveAdd
    if (editForm.value.id) {
      fun = clueReceiveEdit
    }
    fun(editForm.value)
      .then(() => {
        visible.value = false
        emit('success')
        if (editForm.value.id) {
          DcMessage.success('分配区域成功')
        } else {
          DcMessage.success('新增成功')
        }
      })
      .finally(() => {
        loading.value = false
      })
  })
}
const toggle = (rows?: ClueReceiveListItem) => {
  editForm.value = {
    ...rows
  }
  visible.value = true
}
defineExpose({
  toggle
})
</script>
<script lang="ts">
export default { name: 'ClueReceiveAddModel' }
</script>
